export default "__VITE_ASSET__kBQBKJME__"